import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import classes from "./Homescreen.module.css";
import { NavLink, Outlet, redirect } from "react-router-dom";
import { auth } from "../firebase-config";
import clsx from "clsx";

function Homescreen() {
  const [user, setUser] = useState({});
  const [navActive, setNavActive] = useState(false);
  const [mainActive, setMainActive] = useState(false);
  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  }, []);

  const toggleActive = () => {
    setNavActive(!navActive);
    setMainActive(!mainActive);
  };

  const logout = async () => {
    await signOut(auth);
    redirect("/login");
  };

  return (
    <div className={classes.container}>
      <div
        className={clsx(classes.navigation, { [classes.active]: navActive })}
      >
        <ul>
          <li>
            <a href="/">
              <span id={classes.logobig} className={classes.title}></span>
            </a>
          </li>
          {user.email === "info@leveladvise.com" ? (
            <div>
              <h4>Admin</h4>
              <li>
                <NavLink to="/home/clients/">
                  <a href="/">
                    <span className={classes.icon}>
                      <ion-icon name="document-text-outline"></ion-icon>
                    </span>
                    <span className={classes.title}>List of clients</span>
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink to="/home/addclient">
                  <a href="/">
                    <span className={classes.icon}>
                      <ion-icon name="document-text-outline"></ion-icon>
                    </span>
                    <span className={classes.title}>Add client</span>
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  <a onClick={logout} href="/">
                    <span className={classes.icon}>
                      <ion-icon name="log-in-outline"></ion-icon>
                    </span>
                    <span className={classes.title}>Logout</span>
                  </a>
                </NavLink>
              </li>
            </div>
          ) : (
            <div>
              <li>
                <NavLink
                  to="/home"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  <a href="/">
                    <span className={classes.icon}>
                      <ion-icon name="home-outline"></ion-icon>
                    </span>
                    <span className={classes.title}>Welcome!</span>
                  </a>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/home/info"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  <a href="/home/info">
                    <span className={classes.icon}>
                      <ion-icon name="information-circle-outline"></ion-icon>
                    </span>
                    <span onClick={toggleActive} className={classes.title}>
                      My Info
                    </span>
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/home/accounting"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  <a href="/home/accounting">
                    <span className={classes.icon}>
                      <ion-icon name="cash-outline"></ion-icon>
                    </span>
                    <span onClick={toggleActive} className={classes.title}>
                      My Accounting
                    </span>
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/home/events"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  <a href="/home/events">
                    <span className={classes.icon}>
                      <ion-icon name="calendar-outline"></ion-icon>
                    </span>
                    <span onClick={toggleActive} className={classes.title}>
                      My Events
                    </span>
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink>
                  <a href="/">
                    <span id="miniLogo" className={classes.icon}>
                      <img
                        style={{ height: "30px", width: "30px" }}
                        alt=""
                        src={require("../utils/img/LAmini.png")}
                      />
                    </span>
                    <span
                      onClick={() => {
                        window.open("https://www.leveladvise.com/ru");
                      }}
                      className={classes.title}
                    >
                      Go to website
                    </span>
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  <a onClick={logout} href="/">
                    <span className={classes.icon}>
                      <ion-icon name="log-in-outline"></ion-icon>
                    </span>
                    <span className={classes.title}>Logout</span>
                  </a>
                </NavLink>
              </li>
            </div>
          )}
        </ul>
      </div>
      <div
        className={clsx(classes.mainscreen, { [classes.active]: mainActive })}
      >
        <div className={classes.mainscreen_top}>
          <div onClick={toggleActive} className={classes.toggle}>
            <ion-icon name="menu-outline"></ion-icon>
          </div>
          <div className={classes.greetings}></div>
        </div>

        <Outlet />
      </div>
    </div>
  );
}

export default Homescreen;
